export default __webpack_public_path__ + "static/media/missionBanner.9a1b8ae4.png";